import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  dropdownLookup,
  submitForm as submitFormAPICall,
  submitCaptcha as submitCaptchaAPICall,
  requestCaptcha,
  selectCommsMethod,
  getPrepop,
} from "./API";

export const getDropdownData = createAsyncThunk(
  "tr/getDropdownData",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    return dropdownLookup()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const getPrepopDataAsync = createAsyncThunk(
  "tr/prepop",
  async (token, { rejectWithValue, fulfillWithValue }) => {
    return getPrepop(token)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const submitFormAsync = createAsyncThunk(
  "tr/submitForm",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return submitFormAPICall(getState().tr.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const refreshCaptchaAsync = createAsyncThunk(
  "tr/refreshCaptcha",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    return requestCaptcha()
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);
export const submitCaptchaAsync = createAsyncThunk(
  "tr/submitCaptcha",
  async (captcha, { rejectWithValue, fulfillWithValue }) => {
    return submitCaptchaAPICall(captcha)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const selectCommsMethodAsync = createAsyncThunk(
  "tr/selectComms",
  async (_, { getState, rejectWithValue, fulfillWithValue }) => {
    return selectCommsMethod(getState().tr.formState.values)
      .then((res) => fulfillWithValue(res))
      .catch((e) => rejectWithValue(e));
  }
);

export const appSlice = createSlice({
  name: "tr",
  initialState: {
    page: 0,
    loading: false,
    errors: null,
    dropdownoptions: [],
    requiredFiles: [],
    dropdownsloading: false,
    captchaAudio: null,
    captchaImage: null,
    confirmMessage: null,
    confirmTitle: null,
    prepopData: {},
  },
  reducers: {
    updateFormState: (state, action) => {
      state.formState = action.payload;
    },
    cancel: (state) => {
      //Preserve fromData: state.page = 0;
      state.loading = false;
      state.errors = null;
      state.page = 0;
    },
    clearErrors: (state) => {
      state.errors = null;
    },
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setConfirmMessage: (state, action) => {
      state.confirmMessage = action.payload.confirmmessage;
      state.confirmTitle = action.payload.confirmtitle;
    },
    setDefaultIdType: (state, action) => {
      state.formState.values.idtype = action.payload.newId;
      state.formState.values.entitytype = action.payload.newEntity;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDropdownData.pending, (state) => {
        state.dropdownsloading = true;
      })
      .addCase(getDropdownData.fulfilled, (state, action) => {
        state.dropdownsloading = false;
        state.dropdownoptions = action.payload;
      })
      .addCase(getDropdownData.rejected, (state, action) => {
        state.dropdownsloading = false;
        state.errors = action.payload;
      });
    builder
      .addCase(submitFormAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(submitFormAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.captchaImage) {
          state.captchaImage = action.payload.captchaImage;
          state.captchaAudio = action.payload.captchaAudio;
          state.page = 1;
        } else {
          state.contactMethods = action.payload.contactmethods;
          console.log("state.contactMethods " + state.contactMethods);
          state.autoassess = action.payload.assessoutcome;
          state.optoutind = action.payload.optout;
          state.currentind = action.payload.aacurrent;
          console.log("state.currentind " + state.currentind);
          state.page = 2;
        }
      })
      .addCase(submitFormAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      });
    builder
      .addCase(submitCaptchaAsync.fulfilled, (state, action) => {
        console.debug(action, state);
        state.loading = false;
        state.contactMethods = action.payload.contactmethods;
        state.autoassess = action.payload.assessoutcome;
        state.optoutind = action.payload.optout;
        state.currentind = action.payload.aacurrent;
        console.log("state.currentind " + state.currentind);
        state.page = 2;
      })
      .addCase(submitCaptchaAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(submitCaptchaAsync.pending, (state) => {
        state.loading = true;
      });
    builder
      .addCase(refreshCaptchaAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.captchaImage = action.payload.captchaImage;
        state.captchaAudio = action.payload.captchaAudio;
      })
      .addCase(refreshCaptchaAsync.rejected, (state, action) => {
        state.loading = false;
        state.errors = action.payload;
      })
      .addCase(refreshCaptchaAsync.pending, (state) => {
        state.loading = true;
      });
    builder
      .addCase(selectCommsMethodAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(selectCommsMethodAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = null;
        state.confirmMessage = action.payload.confirmmessage;
        state.confirmTitle = action.payload.confirmtitle;
        state.page = 3;
      })
      .addCase(selectCommsMethodAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = action.payload;
        state.otpMethods = null;
      });
    builder
      .addCase(getPrepopDataAsync.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(getPrepopDataAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = null;
        if (state.payload) {
          state.prepopData = true;
        }
        if (action.payload.skipcaptcha == "false") {
          state.formState = { values: action.payload };
          state.isKiosk = true;
          state.skipCaptcha = false;
        } else if (action.payload) {
          state.prepopData = action.payload;
          state.formState = { values: action.payload };
          state.isKiosk = true;
          state.skipCaptcha = true;
        }
        console.log(" skipcaptcha " + state.skipCaptcha);
        console.log(" isKiosk " + state.isKiosk);
      })
      .addCase(getPrepopDataAsync.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.errors = action.payload;
        state.prepopData = {};
        state.message = null;
      });
  },
});

export const {
  cancel,
  updateFormState,
  clearErrors,
  setErrors,
  setPage,
  setConfirmMessage,
  setDefaultIdType,
  selectCommunicationMethod,
} = appSlice.actions;
export const currentPage = (state) => state?.tr?.page;
export const isLoading = (state) => state?.tr?.loading;
export const isKiosk = (state) => state?.tr?.isKiosk;
export const skipCaptcha = (state) => state?.tr?.skipCaptcha;
export const isPrepop = (state) => Object.keys(state?.tr?.prepopData);
export const prepopData = (state) => state?.tr?.prepopData;
export const errors = (state) => state?.tr?.errors;
export const formState = (state) => state?.tr?.formState;
export const dropdownopts = (state) => state?.tr?.dropdownoptions;
export const dropdownsloading = (state) => state?.tr?.dropdownsloading;
export const contactMethods = (state) => state?.tr?.contactMethods;
export const selectedContactMethod = (state) =>
  state?.tr?.selectedContactMethod;
export const autoassess = (state) => state?.tr?.autoassess;
export const optoutind = (state) => state?.tr?.optoutind;
export const currentind = (state) => state?.tr?.currentind;
export const captchaAudio = (state) => state?.tr?.captchaAudio;
export const captchaImage = (state) => state?.tr?.captchaImage;
export const confirmMessage = (state) => state?.tr?.confirmMessage;
export const confirmTitle = (state) => state?.tr?.confirmTitle;

export default appSlice.reducer;
